module.exports = __webpack_public_path__ + "resources/img/ico-company-main-category@2x.cc06726d.png";